import React from "react";
import { useParams, useNavigate } from "react-router";
import { withPermission } from "@/components/auth/withPermission";
import { useProgenyReview } from "@/hooks/useProgenyReview";
import { ReviewDebugView } from "@/components/ops/progeny/ReviewDebugView";
import { ProgenyEnvironmentProvider } from "@/context/ProgenyEnvironmentContext";

export const meta = () => {
  return [
    { title: "Progeny Review Debug | Ani Tech" },
    {
      name: "description",
      content: "Debug view for a specific Progeny review",
    },
  ];
};

export interface OpsProgenyReviewPageContentProps {
  /** Progeny review id (from route param or OS window params) */
  reviewId: string;
  /** Called when user leaves the review view */
  onBack: () => void;
}

/**
 * Progeny review debug UI — shared by the classic route and aniOS window content.
 */
export function OpsProgenyReviewPageContent({
  reviewId,
  onBack,
}: OpsProgenyReviewPageContentProps) {
  const { context, documents, loading, error, refresh } =
    useProgenyReview(reviewId);

  return (
    <div
      className="flex flex-col h-full min-h-0 p-6 overflow-y-auto"
      data-testid="progeny-review-page"
    >
      <ReviewDebugView
        reviewId={reviewId}
        context={context}
        documents={documents}
        loading={loading}
        error={error}
        onRefresh={refresh}
        onBack={onBack}
      />
    </div>
  );
}

function OpsProgenyReviewRouteContent() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const reviewId = id ?? "";

  return (
    <OpsProgenyReviewPageContent
      reviewId={reviewId}
      onBack={() => navigate("/ops/progeny/processing")}
    />
  );
}

function OpsProgenyReviewRoute() {
  return (
    <ProgenyEnvironmentProvider>
      <OpsProgenyReviewRouteContent />
    </ProgenyEnvironmentProvider>
  );
}

export default withPermission(OpsProgenyReviewRoute, "ops");

export const handle = {
  title: "Progeny Review Debug",
  description: "Debug view for a specific Progeny review",
};
